import { EnumProductType } from "gql/generated";

/** Placeholder payment method the server recognizes for booking requests. */
export const BOOKING_REQUEST_PAYMENT_METHOD_ID = "approval_pending";

/**
 * Widgets with booking approval take a request instead of a payment. Paying
 * an invoice through the widget is always a normal payment.
 */
export const isBookingRequestCheckout = ({
  approvalEnabled,
  paymentRequestId,
  productType,
}: {
  approvalEnabled?: boolean | null;
  paymentRequestId?: string | null;
  productType?: EnumProductType | null;
}) =>
  !!approvalEnabled &&
  !paymentRequestId &&
  productType !== EnumProductType.RenewableFee;
